// Shared layout primitives (Section, Field, Stat) used by the Property IC page.
// Extracted from PropertyIC.jsx in iter-13 refactor.
// `compact` on Section/Field tightens padding + label gap. Used by the
// Property Details block so it visually matches the shorter Room Breakdown
// block sitting on its right (Row 1 of the submission page).

export function Section({ icon: Icon, color, title, action, children, compact = false }) {
  const headerPad = compact ? "px-4 py-1.5" : "px-5 py-3";
  const bodyPad = compact ? "p-3" : "p-5";
  return (
    <section className="bg-white border border-zinc-200/80 rounded-xl shadow-sm overflow-hidden">
      <header className={`${headerPad} border-b border-zinc-100 flex items-center justify-between`}>
        <div className="flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4" style={{ color }} />}
          <h3 className="font-display font-bold text-[15px] tracking-tight text-zinc-900">{title}</h3>
        </div>
        {action}
      </header>
      <div className={bodyPad}>{children}</div>
    </section>
  );
}

export function Field({ label, children, span = 1, compact = false }) {
  const labelMargin = compact ? "mb-0.5" : "mb-1";
  // `span` supports 1/2/3 — 3-col grid variant is used by the compressed
  // Property Details block on the submission page.
  const spanClass = span === 3 ? "md:col-span-3" : span === 2 ? "md:col-span-2" : "";
  return (
    <div className={spanClass}>
      <label className={`block text-[11px] font-medium text-zinc-500 ${labelMargin}`}>{label}</label>
      {children}
    </div>
  );
}

export function Stat({ label, value, sub, accent, testid }) {
  return (
    <div className="bg-zinc-50/60 border border-zinc-200/80 rounded-lg p-3" data-testid={testid}>
      <div className="text-[10px] font-medium uppercase tracking-wide text-zinc-500">{label}</div>
      <div className="font-display font-black text-[20px] leading-tight text-zinc-900 mt-0.5">{value}</div>
      {sub && <div className="text-[10px] text-zinc-400 mt-0.5">{sub}</div>}
      {accent && <div className="mt-1.5 h-[3px] w-7 rounded-full" style={{ background: accent }} />}
    </div>
  );
}
